import { render, staticRenderFns } from "./lv-radish-list.vue?vue&type=template&id=06b9a515&scoped=true&"
import script from "./lv-radish-list.vue?vue&type=script&lang=js&"
export * from "./lv-radish-list.vue?vue&type=script&lang=js&"
import style0 from "./lv-radish-list.vue?vue&type=style&index=0&id=06b9a515&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9a515",
  null
  
)

export default component.exports